import {useState, MouseEvent} from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SupportedBrokers } from '../store/dashboard/types';
import { useDispatch, useSelector } from 'react-redux';
import { selectBroker } from '../store/dashboard/selectors';
import { homeActions } from '../store/dashboard/slice';
import { ChevronDown } from '../icons/chevron-down';
import { useRouter } from 'next/router';

const brokers = {
  upstox: 'Upstox',
  angel: 'Angel',
  zerodha: 'Zerodha',
  finvasia: 'Finvasia',
  fyers: 'Fyers'
}

export default function BrokerSelection() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const router = useRouter();
  const dispatch = useDispatch();
  const broker = useSelector(selectBroker);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const select = (selected: string)=>{
    dispatch(homeActions.updateBroker(selected as SupportedBrokers));
    router.push(`/dashboard/${selected}`);
    handleClose();
  }

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        color="inherit"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<ChevronDown/>}
      >
        {brokers[broker]}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {Object.keys(brokers).map(b => <MenuItem key={b} onClick={()=>select(b)}>{brokers[b]}</MenuItem>)}
      </Menu>
    </div>
  );
}
